import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
    return (
        <footer className="mt-24 border-t border-ink-300/30 bg-white">
            <div className="container grid gap-8 py-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2">
                        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500 text-white">
                            <ShieldCheck className="h-5 w-5" />
                        </span>
                        <div className="leading-tight">
                            <div className="font-display text-[15px] font-bold text-ink-900">
                                Pflegeheim-Kosten
                            </div>
                            <div className="text-[11px] text-ink-500">für Angehörige</div>
                        </div>
                    </div>
                    <p className="mt-4 max-w-md text-sm text-ink-500">
                        Die mobile Erstplattform für Angehörige in Deutschland: verständliche Orientierung zu
                        Pflegeheimkosten, Eigenanteil und Angehörigen-Entlastungsgesetz. Auf Wunsch mit
                        persönlicher Begleitung.
                    </p>
                </div>
                <div>
                    <div className="mb-3 font-display text-sm font-semibold">Plattform</div>
                    <ul className="space-y-2 text-sm text-ink-700">
                        <li><Link to="/check" className="hover:text-brand-600">Check starten</Link></li>
                        <li><Link to="/pakete" className="hover:text-brand-600">Beratungspakete</Link></li>
                        <li><Link to="/ratgeber" className="hover:text-brand-600">Ratgeber</Link></li>
                        <li><Link to="/faq" className="hover:text-brand-600">FAQ</Link></li>
                        <li><Link to="/dokumente" className="hover:text-brand-600">Dokumentenprüfung</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="mb-3 font-display text-sm font-semibold">Rechtliches</div>
                    <ul className="space-y-2 text-sm text-ink-700">
                        <li><Link to="/datenschutz" className="hover:text-brand-600">Datenschutz</Link></li>
                        <li><Link to="/impressum" className="hover:text-brand-600">Impressum</Link></li>
                        <li><Link to="/kontakt" className="hover:text-brand-600">Kontakt</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-ink-300/30 py-5 text-center text-xs text-ink-500">
                © {new Date().getFullYear()} pflegeheim-kosten-fuer-angehoerige.de · Keine automatisierte
                Rechtsberatung. Hinweise ersetzen keine individuelle Prüfung.
            </div>
        </footer>
    );
}
